/*
  Links straight to an answer on the FAQ page (Avada FAQ app, #AVADA_PAGE_FAQS):
    /pages/avada-faqs?faq=how%20do%20i%20wash
  types the text into the FAQ search box and opens the first matching question,
  exactly as if the shopper had searched and clicked it. Used by the MACHINE
  WASHABLE tab on product pages (templates/product*.json).

  The app has no link format of its own, so this drives its search box and its
  question button (div.Avada-Accordion_Item-Button, opened by mouse events). If
  the app changes its markup the link still opens the FAQ page, just not the
  answer. Loaded from layout/theme.liquid on pages only; does nothing without ?faq=.
*/
(function () {
  var query = new URLSearchParams(window.location.search).get('faq');
  if (!query) return;

  var tries = 0;
  var timer = setInterval(function () {
    var box = document.querySelector('#AVADA_PAGE_FAQS input.Avada-Faq_Search-Box');
    if (box) {
      clearInterval(timer);
      search(box);
    } else if (++tries > 60) {
      clearInterval(timer); // 15 seconds: the app did not load
    }
  }, 250);

  function search(box) {
    // the app listens to input events; set the value the way typing does
    var setValue = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
    setValue.call(box, query);
    box.dispatchEvent(new Event('input', { bubbles: true }));
    setTimeout(openFirst, 600);
  }

  function openFirst() {
    var items = document.querySelectorAll('#AVADA_PAGE_FAQS .Avada-Accordion_Item');
    for (var i = 0; i < items.length; i += 1) {
      if (!items[i].offsetHeight) continue; // hidden by the search
      var button = items[i].querySelector('.Avada-Accordion_Item-Button');
      if (button && button.getAttribute('aria-expanded') !== 'true') {
        ['pointerdown', 'mousedown', 'pointerup', 'mouseup', 'click'].forEach(function (type) {
          button.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));
        });
      }
      var top = items[i].getBoundingClientRect().top + window.pageYOffset - 140;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      return;
    }
  }
})();
